import { Component, inject, Inject } from '@angular/core';
import { VersionType } from 'src/app/shared/enums/version-type';
import { CollectionListDataInstance } from 'src/app/shared/interfaces/collection-list-data-instance';
import { CollectionInstanceCompareDto } from 'src/models/ts/collection-instance-compare-dto.model';
import { GridService } from 'src/app/features/bizzmine/widgets/collection-list-widget/services/grid/grid.service';
import { CollectionListApiService } from 'src/app/api/bizzmine/collection-list/collection-list-api.service';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { FolderInstanceTargetType } from 'src/models/ts/folder-instance-target-type.model';
import { InstanceComparisonModalModel } from './compare-modal-model';
import { HttpClient } from '@angular/common/http';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { DownloadService } from 'src/app/core/services/download/download.service';

@Component({
  selector: 'bizz-compare-base-modal',
  standalone: true,
  imports: [],
  templateUrl: './compare-base-modal.component.html',
  styleUrl: './compare-base-modal.component.scss'
})

export class CompareBaseModalComponent {
  protected selectedVersion?: VersionType = undefined;
  protected deleteReason = '';
  protected model: CollectionInstanceCompareDto;
  protected data: Partial<CollectionListDataInstance>;
  protected modalType: CompareModalType = CompareModalType.Read;
  protected downloadService = inject(DownloadService);
  public constructor(public dialogRef: DialogRef<CollectionListDataInstance>,
                     @Inject(DIALOG_DATA) public modalData: InstanceComparisonModalModel,
                     protected collectionListService: CollectionListApiService,
                     protected gridService: GridService,
                     protected http: HttpClient, 
                     public pwaService: PwaService,
                     public networkService: NetworkService,
                    ) {
    this.dialogRef.disableClose = true;
    const { comparison, modalType, ...rest } = this.modalData;
    this.model = comparison;
    this.data = rest;
    this.modalType = modalType;
  }

  protected setSelectedVersion(version: VersionType): void {
    this.selectedVersion = version;
  }

  protected get hasData(): boolean {
    return Object.entries(this.model)?.length > 0;
  }

  protected get hasPublic(): boolean {
    return Object.entries(this.model.PublicVersion)?.length > 0;
  }

  protected get hasArchived(): boolean {
    return Object.entries(this.model.ArchiveVersion)?.length > 0;
  }

  protected get hasDraft(): boolean {
    return Object.entries(this.model.DraftVersion)?.length > 0;
  }

  protected get hasPrepublication(): boolean {
    return Object.entries(this.model.PrepublicationVersion)?.length > 0;
  }

  protected getVersionIdByType(versionType: VersionType): number | undefined {
    const versionIdKey = 'VersionsID';
    switch (versionType) {
      case VersionType.Draft:
        return Number(this.model.DraftVersion[versionIdKey]?.Value);
      case VersionType.Public:
        return Number(this.model.PublicVersion[versionIdKey]?.Value);
      case VersionType.Prepublication:
        return Number(this.model.PrepublicationVersion[versionIdKey]?.Value);
      case VersionType.Archive:
        return Number(this.model.ArchiveVersion[versionIdKey]?.Value);
      default:
        return undefined;
    }
  }

  protected readonly FolderInstanceTargetType = FolderInstanceTargetType;
  protected readonly VersionType = VersionType;
}

//Note download compare remains seperate modal
export enum CompareModalType {
  Read,
  Edit,
  Delete,
  ViewOnline,
  EditOnline
}